
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M34.292 14.736h-6.668V12.67h2.13V8.568c0-.371.013-.757.013-.757h-.028a1.86 1.86 0 01-.392.523l-.608.536-1.409-1.486 2.703-2.492h2.114v7.779h2.142l.003 2.065zM5.063 8.706h3.578V4.883h2.374v3.825h3.578v2.232h-3.578v3.808H8.641V10.94H5.063V8.707zm17.055 10.14h17.38a.498.498 0 00.502-.494V1.275a.497.497 0 00-.501-.493H22.118a.497.497 0 00-.502.493v17.077c0 .272.225.493.502.493zM9.828 0C4.4 0 0 4.325 0 9.66v.68C0 15.673 4.399 20 9.826 20c5.427 0 9.828-4.323 9.829-9.658v-.683c0-5.334-4.4-9.659-9.827-9.659z","fill":"currentColor"}})])
          )
        }
      }
    